// Golf Elite OWNER allowlist. Any signed-in user whose email is listed here gets
// permanent, lifetime, full platform access — treated as an always-active
// subscription, bypassing Stripe/billing entirely, never gated, never expiring.
// Edit this list to add/remove owners.
export const OWNER_EMAILS = [
  'yesnetlabs@gmail.com',
  'wmratliff@gmail.com',
]

export function isOwnerEmail(email) {
  return !!email && OWNER_EMAILS.includes(String(email).trim().toLowerCase())
}
